import type { MetaFunction } from "@remix-run/node";
import { getSeoMeta } from "~/utils/seo-meta";
import { SEOLayout } from "~/components/seo/SEOLayout";
import { BlogPostPage } from "~/components/seo/BlogPostPage";
import { BLOG_POSTS } from "~/utils/seo-blog-content";

const POST = BLOG_POSTS["customer-retention-strategies"];

export const meta: MetaFunction = () =>
  getSeoMeta({ title: POST.title, description: POST.description, url: `/blog/${POST.slug}`, type: "article" });

export default function BlogCustomerRetention() {
  return (
    <SEOLayout>
      <BlogPostPage content={POST} />
    </SEOLayout>
  );
}
